import { computed } from 'vue'
import { t } from '@/locales'

// Mirrors the "Leveringer"/"Analyser" tab labels in OrdersView.vue's own
// `navItems` — kept as a separate, lightweight list here rather than reusing
// that computed directly, since it also carries `isActive`/route-reactive
// state that's irrelevant to the page lookup palette. "Orders" itself is
// intentionally omitted — it's already covered by the top-level nav entry
// in useNavItems.ts. Update this alongside OrdersView.vue if these tabs change.
export function useOrdersTabs() {
  return computed<{ label: string; routeName: string }[]>(() => [
    { label: t('W: Leveringer'), routeName: 'OrdersDeliveries' },
    { label: t('W: Analyser'), routeName: 'OrdersAnalyses' },
  ])
}
